import React, { useEffect } from 'react';

const toastColors = {
  success: 'bg-green-100 text-green-800 border-green-300',
  error: 'bg-red-100 text-red-800 border-red-300',
  info: 'bg-blue-100 text-blue-800 border-blue-300',
  warning: 'bg-yellow-100 text-yellow-800 border-yellow-300',
};
const toastColorsDark = {
  success: 'bg-green-900 text-green-100 border-green-700',
  error: 'bg-red-900 text-red-100 border-red-700',
  info: 'bg-blue-900 text-blue-100 border-blue-700',
  warning: 'bg-yellow-900 text-yellow-100 border-yellow-700',
};

export default function Toast({ message, type = 'info', onClose, duration = 3000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose && onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const isDark = document.body.classList.contains('dark');
  const colorClass = isDark ? toastColorsDark[type] : toastColors[type];

  return (
    <div
      className={`pointer-events-auto px-4 py-3 rounded-xl border shadow-lg flex items-center gap-3 animate-fade-in-up transition-all duration-300 ${colorClass} min-w-[220px] max-w-xs`}
      role="alert"
    >
      <span className="flex-1 font-semibold text-sm">{message}</span>
      <button
        onClick={onClose}
        className="ml-2 text-lg font-bold opacity-60 hover:opacity-100 focus:outline-none"
        aria-label="Kapat"
      >
        ×
      </button>
    </div>
  );
}

// Animasyon için index.css veya global css'e eklenmesi gerekenler:
// .animate-fade-in-up { animation: fadeInUp 0.3s cubic-bezier(0.4,0,0.2,1); }
// @keyframes fadeInUp { from { opacity:0; transform:translateY(20px);} to { opacity:1; transform:translateY(0);} } 